<template>
  <NoticeList />
</template>

<script>
import NoticeList from '@/components/notice/NoticeList.vue'

export default {
  components: {
    NoticeList,
  },
}
</script>
